import { AuthService } from 'app/store/services/auth.service';
import { UserState } from 'app/store/models/user.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { setBannerComponent } from 'app/store/actions/page.action';
import { getIsAuthenticated } from 'app/store/selectors/user.selector';
import { IReducers } from '../../../../store/reducers';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit, OnDestroy {
  loginForm: FormGroup;
  showAlert: boolean;
  alertMessage: string;

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private store: Store<IReducers>,
    private router: Router,
    private authService: AuthService,
  ) {
    this.store.dispatch(setBannerComponent({ banner: 'Login' }));
    // this.store.dispatch(init());
  }

  get username(): AbstractControl {
    return this.loginForm.get('username');
  }

  get password(): AbstractControl {
    return this.loginForm.get('password');
  }

  onSubmit = () => {
    if (this.loginForm.invalid) {
      return;
    }

    this.authService.login(this.username.value, this.password.value);
  };

  onKeyDown(event: any) {
    if (event.keyCode === 13) {
      this.onSubmit();
    }
  }

  ngOnInit() {
    this.loginForm = new FormGroup({
      username: new FormControl('', [
        Validators.required,
        Validators.minLength(4),
      ]),
      password: new FormControl('', [
        Validators.required,
        Validators.minLength(6),
      ]),
    });

    this.store.select('user').subscribe((state: UserState) => {
      if (state.redirectRequired === true && state.redirectTo) {
        this.router.navigate(['/' + state.redirectTo.route], {
          queryParams: state.redirectTo.params,
        });
      }
      if (state.status && state.status === 'error' && state.error) {
        this.showAlert = true;
        this.alertMessage = state.error.error.message;
        setTimeout(() => this.closeAlert(), 5000);
      }
    });

    this.store
      .select(getIsAuthenticated)
      .subscribe((isAuthenticated: boolean) => {
        if (isAuthenticated) {
          localStorage.setItem('comming_from', 'login');

          this.router.navigate(['/messages']);
        }
      });
  }

  closeAlert() {
    this.showAlert = false;
    this.alertMessage = null;
  }

  ngOnDestroy(): void {
    this.destroy$.next(false);
  }
}
